import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Chip,
  Divider,
  Button,
} from '@mui/material';
import { MedicalServices, AccessTime, AttachMoney, Edit } from '@mui/icons-material';
import { CaretakerProfile } from '../services/caretakerProfileService';

interface CaretakerServicesProps {
  services: CaretakerProfile['services'];
  isOwner?: boolean;
  onManageServices?: () => void;
}

const CaretakerServices: React.FC<CaretakerServicesProps> = ({ services, isOwner = false, onManageServices }) => {
  console.log('🔍 CaretakerServices - Received services:', services);
  console.log('🔍 CaretakerServices - Services type:', typeof services);
  console.log('🔍 CaretakerServices - Services length:', services?.length);
  console.log('🔍 CaretakerServices - Services array:', Array.isArray(services));
  
  const formatDuration = (minutes: number | null): string => {
    if (!minutes) return 'Duration not specified';
    
    if (minutes < 60) {
      return `${minutes} minutes`;
    }
    
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    
    if (remainingMinutes === 0) {
      return `${hours} hour${hours !== 1 ? 's' : ''}`;
    }
    
    return `${hours}h ${remainingMinutes}m`;
  };

  const formatPrice = (price: number | string | null): string => {
    if (!price) return 'Price available upon request';
    // Convert to number if it's a string (API might return string instead of number)
    const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(numericPrice)) return 'Price available upon request';
    return `$${numericPrice.toFixed(2)}`;
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" component="h2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MedicalServices />
            Services Offered
          </Typography>
          {isOwner && onManageServices && (
            <Button
              variant="outlined"
              startIcon={<Edit />}
              onClick={onManageServices}
              size="small"
            >
              Manage Services
            </Button>
          )}
        </Box>
        
        {services.length > 0 ? (
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <React.Fragment key={service.id}>
                <Grid item xs={12}>
                  <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                    <Typography variant="h6" gutterBottom>
                      {service.name}
                    </Typography>
                    
                    {service.description && (
                      <Typography variant="body2" color="text.secondary" paragraph>
                        {service.description}
                      </Typography>
                    )}
                    
                    <Box display="flex" gap={2} flexWrap="wrap">
                      <Chip
                        icon={<AccessTime />}
                        label={formatDuration(service.duration)}
                        size="small"
                        variant="outlined"
                      />
                      <Chip
                        icon={<AttachMoney />}
                        label={formatPrice(service.price)}
                        size="small"
                        variant="outlined"
                        color="primary"
                      />
                    </Box>
                  </Box>
                </Grid>
                {index < services.length - 1 && (
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </Grid>
        ) : (
          <Typography variant="body1" color="text.secondary">
            No services listed yet.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default CaretakerServices;
